import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBarChart2 } = FiIcons;

export default function Brand({ compact = false }) {
  return (
    <div className="brand">
      <span className="brand-mark">
        <SafeIcon icon={FiBarChart2} />
      </span>
      {!compact && (
        <span>
          <strong>Cencey</strong>
          <small>ذكاء الإيرادات للعيادات</small>
        </span>
      )}
    </div>
  );
}